export default __webpack_public_path__ + "static/media/default-avatar.0a341947.svg";